import React, { useState, useEffect, useRef } from "react";
import BreadCrumb from "../../components/BreadCrumb"; // For breadcrumbs data import
import useStyles from "../../components/Style"; // Import the mantine custome styles from the compoents
import {
  Skeleton,
  Card,
  TextInput,
  Group,
  Text,
  Button,
  Drawer,
  Table,
  ScrollArea,
  NativeSelect,
  Pagination,
  Menu,
  ActionIcon,
  Progress,
  NumberInput,
  Modal,
  Grid,
} from "@mantine/core"; //For import mantine required functions and theme // Mantine all required compoennts imports list
import {
  CloudUpload,
  Dots,
  Pencil,
  Search,
  Trash,
  X,
} from "tabler-icons-react"; // For particular icons that has used in this page from tabler icon // For import the icons
import { useForm } from "@mantine/form"; // Mantine form import
import { CSVLink } from "react-csv"; // For export the data to excel format
import {
  handleAddVendor,
  handleBulkVendor,
  handleDeleteVendor,
  handleEditVendor,
  handleGetVendor,
} from "../../helpers/apis"; // For connect to the electron backend from this helper apis // Import for axios requests list for this pages
import notificationHelper from "../../helpers/notification"; // Import notification for this page
import { Th, dataSearch, setSorting, print } from "../../helpers/tableFunction"; // For table data functions
import { dataSlice, onDownload } from "../../helpers/common"; // Common fuctions uses for applications
import { useModals } from "@mantine/modals"; // Modal from mantine
import excel from "../../assets/images/excel.png"; // Image for excel export
import pdf from "../../assets/images/pdf.png"; // Image for pdf exports
import { useInterval } from "@mantine/hooks";
import readXlsxFile from "read-excel-file";

function Vendor() {
  // Mantine custome style use
  const { classes } = useStyles();
  const modals = useModals();

  // Setting the variables data for table data
  const [sortedData, setSortedData] = useState([]); // For table data
  const [activePage, setPage] = useState(1); // For set table active page
  const [total, setTotal] = useState(10); // For set total list show in page
  const [search, setSearch] = useState(""); // For set the search value name of table
  const [sortBy, setSortBy] = useState(null); // Seting the sortby table type
  const [reverseSortDirection, setReverseSortDirection] = useState(false); // For set the reverse sort direction
  const [refreshTable, setRefreshTable] = useState(Date.now()); // For refresh table

  // Setting the variables data list here
  const [variables, setVariables] = useState({
    skeletonLoading: true,
    submitLoading: false,
    data: [],
    addDrawer: false,
    bulkDrawer: false,
    openEdit: false,
    deleteIndex: 0,
  });

  // For form validation
  const form = useForm({
    initialValues: {
      name: "",
      phone_number: "",
      phone_number2: "",
      gstin: "",
      door_no: "",
      street: "",
      locality: "",
      pincode: "",
      city: "",
      state: "",
    },
    validate: {
      name: (value) => (value.length < 1 ? "Vendor name is required" : null),
    },
  });

  //   For edit form data validation
  const formEdit = useForm({
    initialValues: {
      value: "",
      name: "",
      phone_number: "",
      phone_number2: "",
      gstin: "",
      door_no: "",
      street: "",
      locality: "",
      pincode: "",
      city: "",
      state: "",
    },
    validate: {
      name: (value) => (value.length < 1 ? "Vendor name is required" : null),
    },
  });

  //   For intial setting data
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      if (mounted) {
        //   For get all the vendor data list
        const response = await handleGetVendor();
        // On Respose setting the data to variable
        if (response.status === 200) {
          setVariables({
            ...variables,
            data: response.data.data,
            skeletonLoading: false,
          });
          const datas = dataSlice({
            data: response.data.data,
            page: 1,
            total: 10,
          });
          setSortedData(datas);
        }
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  // Table data arrabnge by using function and loop throw each data rrange to table body
  const rows = sortedData.map((row, index) => (
    <tr key={row.label}>
      <td>{activePage * total - total + index + 1}</td>
      <td>{row.label}</td>
      <td>{new Date(row.createdAt).toLocaleDateString("en-UK")}</td>
      {/* For action drop down edit and delete the data */}
      <td justifycontent="right" align="right">
        <Menu shadow="sm" size="xs">
          <Menu.Target>
            <ActionIcon
              color="zevcore"
              type="button"
              style={{ marginLeft: 10 }}
              size="xs"
            >
              <Dots />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              onClick={() => handleEdit(row.value)}
              icon={<Pencil size={14} />}
            >
              Edit
            </Menu.Item>
            <Menu.Item
              onClick={() => openConfirmModal(row.value)}
              icon={<Trash size={14} />}
            >
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </td>
    </tr>
  ));

  // For delete confirm modal show Delete
  const openConfirmModal = (e) => {
    setVariables({ ...variables, deleteIndex: e });
    modals.openConfirmModal({
      title: "Do you want to delete this vendor value",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { color: "red" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => handleConfirmDelete(e),
    });
  };
  // For delete db data from table and db
  const handleConfirmDelete = async (e) => {
    const response = await handleDeleteVendor(e);
    // Check the response for notification and actions

    if (response.status === 200) {
      notificationHelper({
        color: "green",
        title: "Success",
        message: "Vendor deleted successfully",
      });
      var filter = variables.data;
      filter = filter.filter((img) => img.value !== e);
      setVariables({
        ...variables,
        submitLoading: false,
        data: filter,
      });
      const datas = dataSlice({
        data: filter,
        page: activePage,
        total: total,
      });
      setSortedData(datas);
    } else {
      notificationHelper({
        color: "red",
        title: "Failed! Please enter correct details",
        message: response.data.message,
      });
      setVariables({ ...variables, submitLoading: false });
    }
  };

  //   set editable data to form Edit form
  const handleEdit = (e) => {
    var datas = variables.data.find((img) => img.value === e);
    formEdit.setFieldValue("value", datas.value);
    formEdit.setFieldValue("name", datas.label);
    formEdit.setFieldValue("phone_number", datas.phone_number);
    formEdit.setFieldValue("phone_number2", datas.phone_number2);
    formEdit.setFieldValue("gstin", datas.gstin);
    formEdit.setFieldValue("door_no", datas.door_no);
    formEdit.setFieldValue("street", datas.street);
    formEdit.setFieldValue("locality", datas.locality);
    formEdit.setFieldValue("pincode", Number(datas.pincode));
    formEdit.setFieldValue("city", datas.city);
    formEdit.setFieldValue("state", datas.state);
    setVariables({ ...variables, deleteIndex: e, openEdit: true });
  };

  // Edit vendor data compoennt
  const EditVendor = async (e) => {
    setVariables({ ...variables, submitLoading: true });
    const response = await handleEditVendor(e);
    // Check for response data for actions
    if (response.status === 200) {
      notificationHelper({
        color: "green",
        title: "Success",
        message: "Vendor updated successfully",
      });
      setVariables({
        ...variables,
        data: response.data.data,
        skeletonLoading: false,
      });
      const datas = dataSlice({
        data: response.data.data,
        page: activePage,
        total: total,
      });
      setSortedData(datas);
    } else {
      notificationHelper({
        color: "red",
        title: "Failed! Please enter correct details",
        message: response.data.message,
      });
      setVariables({ ...variables, submitLoading: false });
    }
  };

  // Add new vendor data
  const AddVendor = async (e) => {
    setVariables({ ...variables, submitLoading: true });
    const response = await handleAddVendor(e);
    // Check for response for actions
    if (response.status === 200) {
      notificationHelper({
        color: "green",
        title: "Success",
        message: "Vendor added successfully",
      });
      form.reset();
      setVariables({
        ...variables,
        submitLoading: false,
        data: response.data.data,
      });
      const datas = dataSlice({
        data: response.data.data,
        page: activePage,
        total: total,
      });
      setSortedData(datas);
    } else {
      notificationHelper({
        color: "red",
        title: "Failed! Please enter correct details",
        message: response.data.message,
      });
      setVariables({ ...variables, submitLoading: false });
    }
  };
  // For bulk upload
  const [bulkData, setBulkData] = useState([]);
  const ref = useRef();
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const bulkFile789 = async (event) => {
    let xlsxfile = event.target.files ? event.target.files[0] : null;

    var data = [];
    readXlsxFile(xlsxfile).then((rows) => {
      data = rows;
      setBulkData(data);
    });

    ref.current.value = "";
  };
  const interval = useInterval(
    () =>
      setProgress((current) => {
        if (current < 100) {
          return current + 1;
        }
        return 0;
      }),
    20
  );
  // Upload bulk json data vendor
  const BulkDataUpload = async () => {
    setVariables({ ...variables, submitLoading: true });

    const response = await handleBulkVendor(bulkData);
    // Check for response for actions
    if (response.status === 200) {
      interval.stop();
      notificationHelper({
        color: "green",
        title: "Success",
        message: "Bulk vendor added successfully",
      });
      form.reset();
      setVariables({
        ...variables,
        submitLoading: false,
        data: response.data.data,
      });
      const datas = dataSlice({
        data: response.data.data,
        page: activePage,
        total: total,
      });
      setSortedData(datas);
    } else {
      interval.stop();
      notificationHelper({
        color: "red",
        title: "Failed! Please enter correct details",
        message: response.data.message,
      });
      setVariables({ ...variables, submitLoading: false });
    }
  };

  return (
    <div>
      {/* For breadcrumbs */}
      <Skeleton radius="md" visible={variables.skeletonLoading}>
        <BreadCrumb Text="Vendor" />
      </Skeleton>

      {/* Main start here */}
      <Skeleton radius="md" visible={variables.skeletonLoading}>
        <Card className="border">
          <ScrollArea>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {/* For search the table data input forms */}
              <TextInput
                variant="filled"
                placeholder="Search by any field"
                mb="md"
                size="xs"
                value={search}
                icon={<Search size={14} />}
                onChange={async (e) => {
                  // On change search ofr the data that is enter
                  setSearch(e.currentTarget.value);
                  setPage(1);
                  const datas = await dataSearch({
                    data: variables.data,
                    value: e.currentTarget.value,
                    activePage: activePage,
                    total: total,
                  });
                  setSortedData(datas);
                  setRefreshTable(new Date());
                }}
                sx={{ width: 250 }}
              />
              <div>
                <Group spacing="xs">
                  {/* For export the the table data to pdf and excels */}
                  <Text>Exports :</Text>
                  <CSVLink
                    data={variables.data}
                    headers={[{ label: " Vendor Name", key: "label" }]}
                    filename="vendor.csv"
                    className={classes.pdfExcel}
                  >
                    <img
                      src={excel}
                      alt="excel"
                      width="25"
                      style={{ margin: "2px" }}
                    />
                  </CSVLink>
                  <button
                    className={classes.pdfExcel}
                    onClick={() =>
                      print({
                        data: variables.data,
                        list: ["label"],
                        header: ["Vendor Name"],
                      })
                    }
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      width="19"
                      style={{ margin: "2px" }}
                    />
                  </button>
                  {/* Drawer open for adding new vendor data */}
                  <Button
                    variant="outline"
                    color="zevcore"
                    size="xs"
                    onClick={() =>
                      setVariables({ ...variables, addDrawer: true })
                    }
                  >
                    + Add Vendor
                  </Button>
                </Group>
              </div>
            </div>
            {/* Table data view */}
            <Table
              horizontalSpacing="md"
              verticalSpacing="xs"
              className={classes.striped}
            >
              {/* Table header defines */}
              <thead>
                <tr>
                  <Th>Sl.No</Th>
                  <Th
                    sorted={sortBy === "label"}
                    reversed={reverseSortDirection}
                    onSort={async () => {
                      const reversed =
                        "label" === sortBy ? !reverseSortDirection : false;
                      setReverseSortDirection(reversed);
                      setSortBy("label");
                      const datas = await setSorting({
                        data: variables.data,
                        sortby: "label",
                        reversed: reversed,
                        search: search,
                        activePage: activePage,
                        total: total,
                      });
                      setSortedData(datas);
                      setRefreshTable(new Date());
                    }}
                  >
                    Vendor
                  </Th>
                  <Th>Created At</Th>
                  <Th>Action</Th>
                </tr>
              </thead>
              {/* Table body defines from rows function */}
              <tbody key={refreshTable}>
                {rows.length > 0 ? (
                  rows
                ) : (
                  <tr>
                    <td>
                      <Text weight={500} align="center">
                        Nothing found
                      </Text>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </ScrollArea>
          {/* For display the pagination and no of per pages list */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: 15,
            }}
          >
            {/* For number of rows display in table */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Text size="sm" className="zc-pr-3 zc-pt-1">
                Per Page
              </Text>
              <NativeSelect
                size="xs"
                onChange={async (e) => {
                  setTotal(Number(e.currentTarget.value));
                  setPage(1);
                  const datas = await dataSlice({
                    data: variables.data,
                    page: 1,
                    total: Number(e.currentTarget.value),
                  });
                  setSortedData(datas);
                  setRefreshTable(new Date());
                }}
                data={["10", "20", "50", "100"]}
                rightSectionWidth={20}
                sx={{ width: 70 }}
              />
            </div>
            {/* For pagination */}
            <Pagination
              size="xs"
              page={activePage}
              onChange={async (e) => {
                setPage(Number(e));
                const datas = await dataSlice({
                  data: variables.data,
                  page: Number(e),
                  total: total,
                });
                setSortedData(datas);
                setRefreshTable(new Date());
              }}
              total={Math.ceil(variables.data.length / total)}
              color="zevcore"
            />
          </div>
          {variables.data.length > 0 ? (
            <>
              <Text mt={5} align="right" size="sm" color="green">
                Last updated on:&nbsp;
                {new Date(
                  variables.data.reduce(function (r, a) {
                    return r.updatedAt > a.updatedAt ? r : a;
                  }).updatedAt
                ).toLocaleString("en-UK")}
              </Text>
            </>
          ) : null}
        </Card>
      </Skeleton>

      {/* Vendor Add drawer */}
      <Modal
        withCloseButton={false}
        overlayOpacity={0.55}
        padding={0}
        overlayBlur={3}
        size="xl"
        opened={variables.addDrawer}
      >
        {/* Drawer content */}
        <div
          style={{
            display: "flex",
            padding: 0,
            margin: 0,
            justifyContent: "space-between",
            background: "#043c64",
            borderTopRightRadius: 3,
            borderTopLeftRadius: 3,
          }}
        >
          <Text color="#ffffff" size={14} m={5} mt={8} ml={15}>
            Add Vendor
          </Text>
          <ActionIcon
            onClick={() => setVariables({ ...variables, addDrawer: false })}
            m={5}
            sx={{
              "&[data-disabled]": { opacity: 1 },
              "&[data-loading]": { backgroundColor: "#ffffff" },
            }}
          >
            <X size={18} />
          </ActionIcon>
        </div>
        {/* Drawer content */}
        <div className="zc-p-3">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Button
              variant="outline"
              color="zevcore"
              size="xs"
              onClick={() =>
                setVariables({
                  ...variables,
                  bulkDrawer: true,
                  addDrawer: false,
                })
              }
            >
              Bulk Import
            </Button>
          </div>
          <div className="zc-pt-4 zc-pr-3 zc-pl-3">
            {/* Vendor adding form name */}
            <form onSubmit={form.onSubmit((values) => AddVendor(values))}>
              <Grid>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    value={form.values.name}
                    label="Vendor Name"
                    placeholder="Vendor Name"
                    {...form.getInputProps("name")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    maxLength={10}
                    value={form.values.phone_number}
                    label="Phone Number"
                    placeholder="Phone Number"
                    {...form.getInputProps("phone_number")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    maxLength={10}
                    value={form.values.phone_number2}
                    label="Alternate Phone Number"
                    placeholder="Alternate Phone Number"
                    {...form.getInputProps("phone_number2")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    value={form.values.gstin}
                    label="Vendor GSTIN"
                    placeholder="Vendor GSTIN"
                    {...form.getInputProps("gstin")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    value={form.values.door_no}
                    label=" Door No"
                    placeholder=" Door No"
                    {...form.getInputProps("door_no")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    value={form.values.street}
                    label=" Street"
                    placeholder=" Street"
                    {...form.getInputProps("street")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <NumberInput
                    variant="filled"
                    value={form.values.pincode}
                    label="Pincode"
                    placeholder="Pincode"
                    {...form.getInputProps("pincode")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    value={form.values.locality}
                    label=" Locality"
                    placeholder=" Locality"
                    {...form.getInputProps("locality")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    value={form.values.city}
                    label=" City"
                    placeholder=" City"
                    {...form.getInputProps("city")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <TextInput
                    variant="filled"
                    value={form.values.state}
                    label=" State"
                    placeholder=" State"
                    {...form.getInputProps("state")}
                  />
                </Grid.Col>
                <Grid.Col md={4} lg={4} mt={1}>
                  <Button
                    mt="xl"
                    mb={60}
                    type="submit"
                    fullWidth
                    color="zevcore"
                    loading={variables.submitLoading}
                  >
                    Submit
                  </Button>
                </Grid.Col>
              </Grid>
            </form>
          </div>
        </div>
      </Modal>
      {/* Vendor add drawer end */}

      {/* Vendor Edit drawer */}
      <Modal
        opened={variables.openEdit}
        withCloseButton={false}
        overlayOpacity={0.55}
        padding={0}
        overlayBlur={3}
        size="lg"
      >
        {/* Drawer content */}
        <div
          style={{
            display: "flex",
            padding: 0,
            margin: 0,
            justifyContent: "space-between",
            background: "#043c64",
            borderTopRightRadius: 3,
            borderTopLeftRadius: 3,
          }}
        >
          <Text color="#ffffff" size={14} m={5} mt={8} ml={15}>
            Edit Vendor
          </Text>
          <ActionIcon
            onClick={() => setVariables({ ...variables, openEdit: false })}
            m={5}
            sx={{
              "&[data-disabled]": { opacity: 1 },
              "&[data-loading]": { backgroundColor: "#ffffff" },
            }}
          >
            <X size={18} />
          </ActionIcon>
        </div>
        <div className="zc-pt-4 zc-pr-3 zc-pl-3">
          {/* Vendor adding form name */}
          <form onSubmit={formEdit.onSubmit((values) => EditVendor(values))}>
            <Grid>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  value={formEdit.values.name}
                  label="Vendor Name"
                  placeholder="Vendor Name"
                  {...formEdit.getInputProps("name")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  maxLength={10}
                  value={formEdit.values.phone_number}
                  label="Phone Number"
                  placeholder="Phone Number"
                  {...formEdit.getInputProps("phone_number")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  maxLength={10}
                  value={formEdit.values.phone_number2}
                  label="Alternate Phone Number"
                  placeholder="Alternate Phone Number"
                  {...formEdit.getInputProps("phone_number2")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  value={formEdit.values.gstin}
                  label="Vendor GSTIN"
                  placeholder="Vendor GSTIN"
                  {...formEdit.getInputProps("gstin")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  value={formEdit.values.door_no}
                  label=" Door No"
                  placeholder=" Door No"
                  {...formEdit.getInputProps("door_no")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  value={formEdit.values.street}
                  label=" Street"
                  placeholder=" Street"
                  {...formEdit.getInputProps("street")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <NumberInput
                  variant="filled"
                  value={formEdit.values.pincode}
                  label="Pincode"
                  placeholder="Pincode"
                  {...formEdit.getInputProps("pincode")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  value={formEdit.values.locality}
                  label=" Locality"
                  placeholder=" Locality"
                  {...formEdit.getInputProps("locality")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  value={formEdit.values.city}
                  label=" City"
                  placeholder=" City"
                  {...formEdit.getInputProps("city")}
                />
              </Grid.Col>
              <Grid.Col md={4} lg={4} mt={1}>
                <TextInput
                  variant="filled"
                  value={formEdit.values.state}
                  label=" State"
                  placeholder=" State"
                  {...formEdit.getInputProps("state")}
                />
              </Grid.Col>
              <Grid.Col md={12} lg={12} mt={1}>
                <Button
                  mt="xl"
                  mb={60}
                  type="submit"
                  fullWidth
                  color="zevcore"
                  loading={variables.submitLoading}
                >
                  Update
                </Button>
              </Grid.Col>
            </Grid>
          </form>
        </div>
      </Modal>
      {/* Vendor edit drawer end */}

      {/* Vendor Bulk drawer */}
      <Modal
        opened={variables.bulkDrawer}
        withCloseButton={false}
        overlayOpacity={0.55}
        padding={0}
        overlayBlur={3}
        size="md"
      >
        <div
          style={{
            display: "flex",
            padding: 0,
            margin: 0,
            justifyContent: "space-between",
            background: "#043c64",
            borderTopRightRadius: 3,
            borderTopLeftRadius: 3,
          }}
        >
          <Text color="#ffffff" size={14} m={5} mt={8} ml={15}>
            Bulk Import
          </Text>
          <ActionIcon
            onClick={() => setVariables({ ...variables, bulkDrawer: false })}
            m={5}
            sx={{
              "&[data-disabled]": { opacity: 1 },
              "&[data-loading]": { backgroundColor: "#ffffff" },
            }}
          >
            <X size={18} />
          </ActionIcon>
        </div>
        {/* Drawer content */}
        <div className="zc-p-3">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>

            <div
              onClick={() => onDownload({ data: "vendor" })}
              style={{
                backgroundColor: "rgba(0,0,0,0)",
                cursor: "pointer",
                paddingTop: 5,
              }}
            >
              <img
                src={excel}
                alt="excel"
                width="25"
                style={{ margin: "2px" }}
              />
            </div>
          </div>
          {/* Vendor Bulk add file */}
          <label className="zc-custom-file-upload">
            <input type="file" ref={ref} onChange={bulkFile789} />
            <CloudUpload size={15}></CloudUpload> Upload Bulk Excel File
          </label>
          <Group position="right" mt="md">
            <Button
              color="zevcore"
              fullWidth
              style={{
                position: "relative",
                transition: "background-color 150ms ease",
              }}
              onClick={() => {
                loaded
                  ? setLoaded(false)
                  : !interval.active && interval.start();
                BulkDataUpload();
              }}
            >
              <div
                style={{
                  position: "relative",
                  zIndex: 1,
                }}
              >
                {progress !== 0
                  ? "Uploading Each Data...."
                  : loaded
                  ? "Bulk Upload Completed"
                  : "Upload files"}
              </div>
              {progress !== 0 && (
                <Progress
                  value={progress}
                  className={classes.progress}
                  color="zevcore"
                  radius="sm"
                />
              )}
            </Button>
          </Group>
        </div>
      </Modal>
      {/* Vendor Bulk drawer end */}
    </div>
  );
}
export default Vendor;
